import $ from 'jquery';

/**
 * Service for fetching administrative AJAX lists.
 * This centralizes all API endpoints and standardized data handling.
 */
const BASE_URL = window.location.origin;

async function fetchList(endpoint, params = {}) {
    let url;
    try {
        url = new URL(endpoint);
    } catch (e) {
        url = new URL(`${BASE_URL}/${endpoint.startsWith('/') ? endpoint.substring(1) : endpoint}`);
    }
    
    // Convert URLSearchParams to a plain object for $.ajax
    const ajaxData = { ...params };
    
    try {
        const result = await $.ajax({
            url: url.toString().split('?')[0], // Base URL
            method: 'GET',
            data: ajaxData,
            dataType: 'json',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (result && result.status === 'success') {
            return result.data || [];
        }
        return [];
    } catch (error) {
        console.error(`[AJAX List] Error fetching ${endpoint}:`, error);
        return [];
    }
}

export const AjaxList = {
    /**
     * Fetch ULP list, optionally filtered by UP3
     */
    getUlp: (id_up3 = null) => fetchList('ulp/ajax-list', { id_up3 }),

    /**
     * Fetch Penyulang list, optionally filtered by ULP
     */
    getPenyulang: (id_ulp = null) => fetchList('penyulang/ajax-list', { id_ulp }),

    /**
     * Fetch Pegawai list, optionally filtered by UP3
     */
    getPegawai: (id_up3 = null) => fetchList('pegawai/ajax-list', { id_up3 }),

    /**
     * Fetch Segment list, optionally filtered by Penyulang
     */
    getSegment: (id_penyulang = null, id_ulp = null) => fetchList('segment/ajax-list', { id_penyulang, id_ulp }),

    /**
     * Fetch Percabangan list, optionally filtered by Penyulang
     */
    getPercabangan: (id_penyulang = null, id_ulp = null) => fetchList('percabangan/ajax-list', { id_penyulang, id_ulp }),

    /**
     * Fetch Objek Pekerjaan list, optionally filtered by Jenis Pekerjaan
     */
    getObjekPekerjaan: (id_jenis = null) => fetchList('objek-pekerjaan/ajax-list', { id_jenis }),

    /**
     * Generic fetcher for any endpoint with params
     */
    fetch: (endpoint, params) => fetchList(endpoint, params)
};

export default AjaxList;
